import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

import {
    PropertiesController,
    usePropertiesController,
} from '../../SidePanel/RightPanel/PropertiesController.jsx'

import SelectUiLayoutType from './SelectUiLayoutType.jsx'

export default function PropertiesControllerSs({
    clalayoutTypeName,
    style,
    codeProp = 'layoutTypeCode',
    disabled,
    hidden,
    idProp = 'layoutTypeId',
    label,
    labelSuffix,
    nameProp = 'layoutTypeName',
    readOnly,
    required,
    ...props
}) {
    const [values, update] = useProperties()
    const {
        [codeProp]: layoutTypeCode,
        [idProp]: layoutTypeId,
        [nameProp]: layoutTypeName,
    } = values

    const handleChange = ss => {
        const {
            layoutTypeCode = '',
            layoutTypeId = '',
            layoutTypeName = '',
        } = ss ?? {}

        update({
            [codeProp]: layoutTypeCode,
            [idProp]: layoutTypeId,
            [nameProp]: layoutTypeName,
        })
    }

    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop: codeProp,
        readOnly,
        required,
    })

    return (
        <PropertiesController
            clalayoutTypeName={clalayoutTypeName}
            style={style}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <SelectUiLayoutType
                isLeaf={false}
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={{layoutTypeCode, layoutTypeId, layoutTypeName}}
                onChange={handleChange}
                multiple={false}
                {...props}
            />
        </PropertiesController>
    )
}
